import { getApiOrigin } from '@/config/env';
import { getToken } from '@/utils/auth';

export type SurveyResponseStatus =
  | 'started'
  | 'otp_pending'
  | 'otp_verified'
  | 'in_progress'
  | 'completed'
  | 'tng_sent';

export type SurveySessionRow = {
  uuid: string;
  createdAt: string;
  updatedAt: string;
  contact: string | null;
  submissionIndex: number | null;
  status: SurveyResponseStatus;
  statusLabel: string;
  otpVerified: boolean;
  age: string | null;
  smoker: string | null;
  language: string | null;
  name: string | null;
  state: string | null;
  prevBrand: string | null;
  summary: string | null;
  tngSent: boolean;
  staffName: string | null;
  staffCode: string | null;
  memberCode: string | null;
};

export type SurveyFunnelStage = {
  key: string;
  label: string;
  count: number;
  pctOfTotal: number;
  pctOfPrevious: number | null;
};

export type SurveyTrackingSummary = {
  totalSessions: number;
  completed: number;
  abandoned: number;
  tngSent: number;
  completionRatePct: number;
};

export type SurveyTrackingData = {
  summary: SurveyTrackingSummary;
  funnel: SurveyFunnelStage[];
  sessions: SurveySessionRow[];
};

export async function fetchSurveyTracking(input: {
  startISO: string;
  endISO: string;
  status?: SurveyResponseStatus | 'all';
}): Promise<SurveyTrackingData> {
  const apiUrl = getApiOrigin();
  const params = new URLSearchParams({
    startDate: input.startISO,
    endDate: input.endISO,
  });
  if (input.status && input.status !== 'all') {
    params.set('status', input.status);
  }

  const res = await fetch(`${apiUrl}/api/v1/admin/survey-tracking?${params.toString()}`, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });

  const body = (await res.json().catch(() => ({}))) as {
    ok?: boolean;
    data?: SurveyTrackingData;
    error?: string;
  };

  if (!res.ok || !body.ok || !body.data) {
    throw new Error(body.error || `Failed to load survey tracking (HTTP ${res.status})`);
  }

  return body.data;
}
